export const SITE_URL = "https://sigvion.com";
export const SITE_NAME = "Sigvion";
export const DEFAULT_IMAGE = `${SITE_URL}/preview.png`;

// Page metadata keyed by the English path (German pages reuse it under /de)
export const pages = {
  "/": {
    title: "Sigvion | IT Solutions, Cloud & Digital Transformation",
    description:
      "Sigvion delivers IT consulting, cloud, business analytics, ERP, DevOps and cyber security services that help enterprises grow through digital transformation.",
  },
  "/about-us": {
    title: "About Us | Sigvion",
    description:
      "Learn about Sigvion, our mission, vision and core values, our certifications, and career opportunities with our global team of technologists.",
  },
  "/contact-us": {
    title: "Contact Us | Sigvion",
    description:
      "Get in touch with Sigvion. Reach our offices in the USA, Germany and India to discuss your IT, cloud, analytics or digital transformation project.",
  },
  "/services/it-solutions": {
    title: "IT Solutions | Sigvion",
    description:
      "Innovative IT solutions that modernize infrastructure, enhance security and drive digital transformation with scalable, cost-effective technology.",
  },
  "/services/it-consulting-services": {
    title: "IT Consulting Services | Sigvion",
    description:
      "Strategic IT consulting to optimize infrastructure, streamline processes and align technology with your business objectives for sustainable growth.",
  },
  "/services/cloud-transformation": {
    title: "Cloud Transformation | Sigvion",
    description:
      "Secure, scalable cloud migration and optimization services that reduce costs, improve collaboration and modernize your IT infrastructure.",
  },
  "/services/business-analytics": {
    title: "Business Analytics | Sigvion",
    description:
      "Turn data into actionable insights with dashboards, BI platforms like Tableau and Power BI, and predictive analytics powered by machine learning.",
  },
  "/services/application-management": {
    title: "Application Management | Sigvion",
    description:
      "End-to-end application management covering monitoring, maintenance, security and modernization to keep your enterprise applications fast and reliable.",
  },
  "/services/erp-procurement-and-supply-chain": {
    title: "ERP, Procurement & Supply Chain | Sigvion",
    description:
      "Integrated ERP, CRM, PLM, procurement and supply chain solutions that unify operations, automate workflows and improve financial visibility.",
  },
  "/services/devops-and-cyber-security": {
    title: "DevOps & Cyber Security | Sigvion",
    description:
      "DevOps automation and cyber security services: CI/CD pipelines, threat detection, compliance and continuous monitoring for secure, faster delivery.",
  },
  "/services/build-operate-transfer": {
    title: "Build, Operate & Transfer (BOT) | Sigvion",
    description:
      "Sigvion's Build, Operate & Transfer model delivers complete project execution, reduces risk and ensures a seamless handover of ownership.",
  },
};

export const notFoundPage = {
  title: "Page Not Found | Sigvion",
  description: "The page you were looking for could not be found.",
};
